import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "permissionsModal",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "permissionsModal"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstInputField",
  class: "mb-3 fs-4"
}, "Role title", -1)
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "secondInputField",
  class: "mb-3 fs-4"
}, "Role description", -1)
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "mb-3 fs-4" }, "Select permissions", -1)
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.setup.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "firstInputField",
              placeholder: _ctx.setup.firstInputValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.valueOfFirstInput) = $event)),
              class: "form-control mb-5 ps-5"
            }, null, 8, _hoisted_9), [
              [
                _vModelText,
                _ctx.values.valueOfFirstInput,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "secondInputField",
              placeholder: _ctx.setup.secondInputValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.valueOfSecondInput) = $event)),
              class: "form-control mb-5 ps-5"
            }, null, 8, _hoisted_11), [
              [
                _vModelText,
                _ctx.values.valueOfSecondInput,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.values.valueOfDropdown,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.valueOfDropdown) = $event)),
                multiple: "",
                size: "large",
                filterable: "",
                "default-first-option": "",
                placeholder: "Select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPermissions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.title,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
          }, " Close "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.emitSaveButtonEvent && _ctx.emitSaveButtonEvent(...args)))
          }, _toDisplayString(_ctx.setup.buttonText), 1)
        ])
      ])
    ])
  ]))
}